function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVickyfineartSendtophotographer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-fe410c78-1f70-46c7-a4c0-cf5e9976e261",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.93 58.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: ".82 16.13 93.66 1.48 60.04 54.74 45.81 45.17 29.06 33.9 30.18 57.06 17.67 27.12 .82 16.13",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17.67 27.12 93.66 1.48 29.06 33.9",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.18,
    y1: 57.06,
    x2: 45.81,
    y2: 45.17,
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVickyfineartSendtophotographer);
export default __webpack_public_path__ + "static/media/vicky fineart - send to photographer.217050bcdd1ba50694041d68a73ce586.svg";
export { ForwardRef as ReactComponent };